import { Box } from '@mui/material';

interface CardColorPickerProps {
  colors: string[];
  onChange: (color: string) => void;
  value: string;
}

export function CardColorPicker({ colors, onChange, value }: CardColorPickerProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 0.75,
        width: 298,
        background: '#ffffff',
        boxShadow: '0px 3px 6px #00000029',
        position: 'absolute',
        right: 0,
        p: 1,
        borderRadius: 1,
      }}
    >
      {colors.map((color) => (
        <Box
          key={color}
          component="button"
          type="button"
          aria-label={`Use color ${color}`}
          onClick={() => onChange(color)}
          sx={{
            bgcolor: color,
            border:
              color.toLowerCase() === value.toLowerCase() ? '2px solid #111' : '1px solid #d0d5dd',
            borderRadius: '50%',
            boxShadow: color === '#ffffff' ? 'inset 0 0 0 1px #e4e7ec' : undefined,
            cursor: 'pointer',
            height: 30,
            width: 30,
            p: 0,
          }}
        />
      ))}
    </Box>
  );
}
